// Delegated capturing listener — runs before inline onclick handlers
(function () {

  // Candidate selectors to disable (add more if your theme uses different classes)
  const BUTTON_SELECTORS = [
    '.gokwik-checkout .button',
    '.shopify-payment-button__button',
    '.product-form__submit',            // other possible checkout/add buttons
  ];

  // Add/Remove disabled state robustly for a container (Drawer or Cart)
  function setDisabledForContainer(container, disabled = true) {
    if (!container) return;

    // 1) find all candidate elements inside container
    const candidates = BUTTON_SELECTORS
      .map(sel => Array.from(container.querySelectorAll(sel)))
      .flat();

    // 2) also include any direct <button> inside gokwik-checkout wrapper
    const extra = Array.from(container.querySelectorAll('.gokwik-checkout button, .gokwik-checkout .button'));
    extra.forEach(el => { if (!candidates.includes(el)) candidates.push(el); });

    // 3) apply the disabled styles/attributes
    candidates.forEach(btn => {
      try {
        if (disabled) {
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('disabled-by-terms');
          btn.setAttribute('aria-disabled', 'true');
          btn.style.pointerEvents = 'none';
          btn.tabIndex = -1;
        } else {
          btn.removeAttribute('disabled');
          btn.classList.remove('disabled-by-terms');
          btn.setAttribute('aria-disabled', 'false');
          btn.style.pointerEvents = '';
          btn.tabIndex = 0;
        }
      } catch (err) {
        // ignore any read-only elements
      }
    });

    // Also toggle a container-level class for styling / fallback
    if (disabled) container.classList.add('terms-disabled');
    else container.classList.remove('terms-disabled');
  }

  // Update states for Drawer and Cart Footer based on checkbox
  function updateAllStates() {
    const drawer = document.querySelector('#CartDrawer');
    const cartFooter = document.querySelector('.cart__footer');

    if (drawer) {
      const chk = drawer.querySelector('#cart-terms-checkbox');
      setDisabledForContainer(drawer, !(chk && chk.checked));
    }
    if (cartFooter) {
      const chk = cartFooter.querySelector('#cart-terms-checkbox');
      setDisabledForContainer(cartFooter, !(chk && chk.checked));
    }
  }

  // Observe container replacements and re-apply disabled state
  function observeContainer(containerSelector) {
    const root = document.querySelector(containerSelector);
    if (!root) return;

    const mo = new MutationObserver(() => {
      // Re-run update to re-disable newly inserted buttons
      updateAllStates();
    });
    mo.observe(root, { childList: true, subtree: true });
    // Keep a reference on the DOM node so you can disconnect later if needed
    root._termsMo = mo;
  }

  // Initialise handlers
  function initTerms() {

    // 1) Initial apply
    updateAllStates();

    // 2) Listen checkbox changes (delegated)
    document.addEventListener('change', function (e) {
      if (e.target.matches('#CartDrawer #cart-terms-checkbox') ||
          e.target.matches('.cart__footer #cart-terms-checkbox')) {
        updateAllStates();
        // hide error if checked
        const container = e.target.closest('#CartDrawer') || e.target.closest('.cart__footer');
        const err = container && container.querySelector('#cart-terms-error');
        if (err && e.target.checked) err.style.display = 'none';
      }
    });

    // 3) Observe drawer and cart footer for dynamic replacements
    observeContainer('#CartDrawer');
    observeContainer('.cart__footer');

    // 4) Re-run on common page events (Shopify AJAX)
    document.addEventListener('shopify:section:load', updateAllStates);
    document.addEventListener('page:load', updateAllStates);
    window.addEventListener('resize', updateAllStates);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTerms);
  } else {
    initTerms();
  }

  // Optional: CSS to make clear visually (you can include this in your theme CSS)
  const css = `
    .disabled-by-terms { opacity: 0.5 !important; pointer-events: none !important; }
    .terms-disabled .gokwik-checkout .button { pointer-events: none; }
  `;
  const style = document.createElement('style');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

})();


// // Delegated capturing listener — runs before inline onclick handlers
// document.addEventListener('click', function (e) {
//   // Matches GoKwik checkout buttons in Drawer or Cart footer
//   const btn = e.target.closest('#CartDrawer .gokwik-checkout .button, .cart__footer .gokwik-checkout .button');
//   if (!btn) return; // not our button

//   // find the container (Drawer or Cart footer)
//   const container = btn.closest('#CartDrawer') || btn.closest('.cart__footer');
//   if (!container) return;

//   const checkbox = container.querySelector('#cart-terms-checkbox');
//   const errorMsg = container.querySelector('#cart-terms-error');

//   // If no checkbox present, do nothing (no validation required)
//   if (!checkbox) return;

//   // If checkbox not checked -> stop everything (prevents inline onclick)
//   if (!checkbox.checked) {
//     e.preventDefault();
//     e.stopImmediatePropagation(); // stops inline onclick and other handlers
//     if (errorMsg) errorMsg.style.display = 'block';
//     // optional: scroll to / focus checkbox for UX
//     checkbox.focus({preventScroll: false});
//     return false;
//   }

//   // Checkbox is checked -> hide error and allow normal flow (incl inline onclick)
//   if (errorMsg) errorMsg.style.display = 'none';
// }, true); // <-- NOTE: 'true' enables capture phase








// document.addEventListener('DOMContentLoaded', () => {
//   function setupValidation(checkboxSelector, errorMsgSelector, btnSelector) {
//     const checkbox = document.querySelector(checkboxSelector);
//     const errorMsg = document.querySelector(errorMsgSelector);
//     const button = document.querySelector(btnSelector);

//     if (!checkbox || !button) return;

//     // Remove inline GoKwik onclick
//     const originalOnClick = button.onclick;
//     button.onclick = null;
 
//     button.addEventListener('click', function (e) {

//       if (!checkbox.checked) {
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         if (errorMsg) errorMsg.style.display = 'block';
//         return false;
//       }

//       if (errorMsg) errorMsg.style.display = 'none';

//       // Trigger original GoKwik function AFTER validation
//       if (typeof originalOnClick === 'function') {
//         originalOnClick.call(button, button);
//       }
//     });
//   }

//   // Drawer (FIXED selector)
//   setupValidation(
//     '#CartDrawer #cart-terms-checkbox',
//     '#CartDrawer #cart-terms-error',
//     '#CartDrawer .gokwik-checkout .button'
//   );

//   // Cart Page (FIXED selector)
//   setupValidation(
//     '.cart__footer #cart-terms-checkbox',
//     '.cart__footer #cart-terms-error',
//     '.cart__footer .gokwik-checkout .button'
//   );
// });
